module.exports = __webpack_public_path__ + "static/media/2032.fadbdae6.svg";